/***
 * Created on 2023/9/5
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import {useTogglePopup} from "../../../hook/hooks";
import {getAppCDNUrl} from "../../../service/common";
import ServiceAppItem from "./service_app_item";
import {getCurrentDomainRegion, CHINA} from "../../../service/common";

const ExcludeServiceForChina = ['Hybrid Backup Center', 'Software Store', 'Qmiix', 'Service Portal']

function ServiceHeader(props) {
    const service_apps = localStorage.getItem('service_apps');
    const {isShow, toggleAction, elemRef} = useTogglePopup();
    const [serviceItems, setServiceItems] = useState(service_apps ? JSON.parse(service_apps) : null);

    const getServiceItems = async () => {
        try {
            const response = await fetch(`${getAppCDNUrl()}/cloud_app/app_info.json`);
            if (!response.ok) {
                throw new Error('Api Request Error', {
                    cause: response
                });
            }
            const res = await response.json();
            setServiceItems(res);
            localStorage.setItem('service_apps', JSON.stringify(res));
            return res;
        } catch (err) {
            if (err?.cause) {
                console.log(err.cause);
            }
            throw new Error(err);
        }
    }

    useEffect(() => {
        if (!serviceItems) {
            getServiceItems();
        }
    }, []);

    useEffect(() => {
        const appHead = document.querySelector('.app-head');
        if (!isShow) {
            appHead.removeAttribute('data-z-index');
        }
        else {
            appHead.setAttribute('data-z-index', 'top');
        }
    }, [isShow])

    return (
        <div className={`util-btn ${isShow ? 'active' : ''}`} ref={elemRef} onClick={toggleAction} util-type="service-box" data-testid="service-header">
            <div className="comp-dropdown hide" data-modal-sheet>
                <ul className="dropdown-menu dropdown-menu--services-grid">
                    {
                         serviceItems?.apps?.filter(app => {
                            if (getCurrentDomainRegion()===CHINA) {
                                return !ExcludeServiceForChina.includes(app.title);
                            }
                            return true;

                        }).map((item, index )=> <ServiceAppItem item={item} key={index}/>)
                    }
                </ul>
            </div>
        </div>
    );
}

export default ServiceHeader;